import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'

export enum QuickReplyType {
  Driver = 'driver',
  Dispatcher = 'dispatcher',
}

export enum QuickReplyStatus {
  Active = 'active',
  Archived = 'archived',
}

export interface IQuickReplyPostBody {
  type: QuickReplyType
  text: string
  order?: string
}

export interface IQuickReplyPatchBody {
  text?: string
  status?: QuickReplyStatus
  order?: string
}

export interface IQuickReplyResponse extends Required<IQuickReplyPostBody>, IModelJsonValues {
  id: string
  createdAt: number
  updatedAt: number
  status: QuickReplyStatus
}

export interface IListQuickRepliesQueryParams extends IListModelQueryParamValues {
  type?: QuickReplyType
  status?: QuickReplyStatus
}
